import { Button, Dialog, Input, Stack, Text } from "@rally/ui-kit";
import { useEffect, useState } from "react";
import { failureSaid } from "../localization/failure.ts";
import { say } from "../localization/say.ts";
import { act } from "../net/rally.ts";

export type AgentNamed = { account: string; handle: string; displayName: string | null };

export function RenameAgent({
  account,
  called,
  name,
  visible,
  onDismiss,
  onRenamed,
}: {
  account: string;

  called: string;

  name: string | null;
  visible: boolean;
  onDismiss: () => void;

  onRenamed: (named: AgentNamed) => void;
}) {
  const [typed, setTyped] = useState(name ?? "");
  const [busy, setBusy] = useState(false);
  const [wrong, setWrong] = useState<string | null>(null);

  useEffect(() => {
    if (visible) {
      setTyped(name ?? "");
      setWrong(null);
    }
  }, [visible, name]);

  const save = async () => {
    setBusy(true);
    setWrong(null);
    try {
      const named = await act<AgentNamed>("agent.setName", { account, name: typed.trim() });
      onRenamed(named);
      onDismiss();
    } catch (cause) {
      setWrong(failureSaid(cause, say("agent.broke")));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog
      visible={visible}
      onDismiss={onDismiss}
      title={say("agent.renameTitle")(called)}
      testID="agent-rename-dialog"
    >
      <Stack gap={3}>
        <Text typeName="caption" color="text.secondary">
          {say("agent.renameMeans")}
        </Text>
        <Input
          value={typed}
          onChangeText={setTyped}
          placeholder={say("agent.namePlaceholder")}
          testID="agent-name-field"
        />
        {wrong ? (
          <Text typeName="caption" color="danger" testID="agent-name-said">
            {wrong}
          </Text>
        ) : null}
        <Button testID="agent-name-save" loading={busy} onPress={() => void save()}>
          {say("agent.save")}
        </Button>
      </Stack>
    </Dialog>
  );
}
